import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Play } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { Logo } from "@/components/site/Header";
import { useWaNumber } from "@/components/site/WhatsAppFab";

const WaPhone = () => {
  const num = useWaNumber();
  if (!num) return null;
  const pretty = `+${num.slice(0, 2)} ${num.slice(2, 5)}-${num.slice(5, 9)}-${num.slice(9)}`;
  return <a href={`https://wa.me/${num}`} target="_blank" rel="noreferrer" data-testid="footer-phone-link" className="flex items-center gap-2 hover:text-white"><Phone className="h-4 w-4 text-amber-400" />{pretty}</a>;
};

export default function Footer() {
  const { t } = useLang();
  const cols = [
    ["/destinations", "nav_destinations"], ["/map", "nav_map"], ["/tours", "nav_tours"],
    ["/cars", "nav_cars"], ["/guides", "nav_guides"], ["/open-trip", "nav_opentrip"],
    ["/planner", "nav_planner"], ["/mitra", "nav_partner"], ["/booking-status", "check_booking"],
  ];
  return (
    <footer className="mt-24 bg-[#022C22] text-emerald-50/80">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-5 space-y-4">
          <Logo light testid="footer-logo" />
          <p className="max-w-sm text-sm leading-relaxed">{t("footer_tag")}</p>
        </div>
        <div className="lg:col-span-3 grid grid-cols-2 gap-2 text-sm">
          {cols.map(([to, k]) => <Link key={to} to={to} data-testid={`footer-link-${to.slice(1)}`} className="hover:text-white transition-colors">{t(k)}</Link>)}
        </div>
        <div className="lg:col-span-4 space-y-3 text-sm">
          <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-amber-400" />Jl. Khatib Sulaiman, Padang, Sumatera Barat</p>
          <WaPhone />
          <a href="mailto:tania@mytaxiguide.com" data-testid="footer-email-link" className="flex items-center gap-2 hover:text-white"><Mail className="h-4 w-4 text-amber-400" />tania@mytaxiguide.com</a>
          <a href="https://www.tiktok.com/@padang_taxi_guide" target="_blank" rel="noreferrer" data-testid="footer-tiktok-link" className="flex items-center gap-2 hover:text-white"><Play className="h-4 w-4 text-amber-400" />TikTok @padang_taxi_guide</a>
        </div>
      </div>
      <div data-testid="footer-copyright" className="border-t border-white/10 px-4 pt-6 pb-24 sm:pb-6 text-center text-xs leading-relaxed [overflow-wrap:anywhere]">© 2026 mytaxiguide.com {t("footer_rights")}</div>
    </footer>
  );
}
